import React from "react";
import { Route, RouteComponentProps } from "react-router-dom";

import { Investments } from "./investments";
import { InvestmentsEdit } from "./InvestmentsEdit";

export const InvestmentRouter = ({ match: { path } }: RouteComponentProps) => {
  return (
    <>
      <Route exact path={`${path}/`} component={Investments} />
      <Route exact path={`${path}/edit`} component={InvestmentsEdit} />
    </>
  );
};
